Core.SelfInvoicingRouter = Core.SubRouter.extend({
    routes: {
        '': 'selfinvoicing',
        ':id': 'selfinvoicingDetail',
    },

    selfinvoicing: function() {
        if (!Core.client.hasFeature('self_invoicing') || !Core.client.hasPermissionInAnyGroup('self_invoicing')) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        app.setMainView(new SelfInvoicingView(), 'selfinvoicing');
    },

    selfinvoicingDetail: function(id) {
        if (!Core.client.hasFeature('self_invoicing') || !Core.client.hasPermissionInAnyGroup('self_invoicing')) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        var toDate = Core.param('toDate');
        var detailView = new SelfInvoiceDetailView({ origin: toDate ? 'todo' : 'history' });
        app.setMainView(detailView, 'selfinvoicing');
        if (toDate) {
            // Generate new invoice for a subcontractor (from "Att göra")
            var onlyInvoiced = Core.param('onlyInvoiced');
            if (onlyInvoiced === undefined || onlyInvoiced === null) onlyInvoiced = 'true';
            $.ajax({
                url: Core.contextRoot + '/selfinvoice/generate/' + id,
                data: { toDate: toDate, onlyInvoiced: onlyInvoiced },
                success: function(data) {
                    var selfInvoice = typeof data === 'string' ? JSON.parse(data) : data;
                    detailView.setData(selfInvoice);
                },
                error: function() {
                    Backbone.history.navigate('selfinvoicing', {trigger: true});
                }
            });
        } else {
            // View an existing saved self-invoice (from history)
            $.ajax({
                url: Core.contextRoot + '/selfinvoice/' + id,
                success: function(data) {
                    var selfInvoice = typeof data === 'string' ? JSON.parse(data) : data;
                    detailView.setData(selfInvoice);
                },
                error: function() {
                    Backbone.history.navigate('selfinvoicing', {trigger: true});
                }
            });
        }
    },
});
